
const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SETDEVCONFIG':

      const aux = [...state];
      const dados = { nome: action.nome, valor: action.valor, header: action.header };

      const inx = aux.findIndex(x => x.nome == dados.nome);

      if (inx > -1)
        aux[inx] = dados;
      else
        aux.push(dados);

      state = aux;

      return state;
    default:
      return state;
  }
};